/**
 * Legacy SfdcApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.sfdcApi`) keep resolving.
 *
 * The actual SfdcApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/sfdc/sfdc-api.service.ts
 */
angular.module("acme.common.service.sfdcApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
